/**
 * Sentry error monitoring for the (app) training shell (issue #252,
 * follow-up on #137). Mirrors lib/analytics/posthog.ts's no-op-when-unset
 * pattern. Uses @sentry/browser (not @sentry/nextjs) — the Next.js SDK's
 * auto-instrumenting build plugin would inject a client init on every
 * route, including (marketing), blowing the 90KB gz marketing JS budget
 * (frontend/CLAUDE.md, eslint.config.mjs's no-restricted-imports wall).
 */
import * as Sentry from '@sentry/browser';

let initialized = false;

export function initErrorMonitoring(): void {
  if (initialized) return;
  const dsn = process.env.NEXT_PUBLIC_SENTRY_DSN;
  if (!dsn) return;
  Sentry.init({
    dsn,
    environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT ?? 'dev',
    tracesSampleRate: 0,
  });
  initialized = true;
}

/** Thin wrapper: no-ops if error monitoring was never initialized (DSN unset). */
export function captureError(error: unknown): void {
  if (!initialized) return;
  Sentry.captureException(error);
}

/** Test-only: resets module state between test files. */
export function resetErrorMonitoringForTests(): void {
  initialized = false;
}
